/**
 * Vietnamese (Tiếng Việt) translations
 * Context: Hibachi catering service for home parties
 */
const vi = {
	nav: {
		home: 'TRANG CHỦ',
		california: 'CALIFORNIA',
		texas: 'TEXAS',
		florida: 'FLORIDA',
		menu: 'THỰC ĐƠN',
		faq: 'CÂU HỎI',
		freeEstimate: 'Báo Giá Miễn Phí',
		bookNow: 'ĐẶT NGAY',
		myBooking: 'Đặt Chỗ Của Tôi',
	},
	seo: {
		homeDescription: 'Trải nghiệm Hibachi tại nhà được đánh giá cao nhất. Chúng tôi mang bếp Hibachi + Đầu bếp đến sân nhà bạn tại California, Texas và Florida.',
	},
	hero: {
		title: 'HAPPY HIBACHI',
		tagline: 'Hibachi Tại Nhà #1 Nước Mỹ',
		subtitle: 'Trải nghiệm nấu ăn Hibachi Nhật Bản chính thống tại nhà bạn',
		description: 'Đầu bếp chuyên nghiệp mang sự thú vị của ẩm thực Hibachi đến tận sân nhà bạn.',
		bookNow: 'Đặt Ngay',
		freeEstimate: 'Báo Giá Miễn Phí',
	},
	howItWorks: {
		title: 'Cách Thức Hoạt Động',
		subtitle: 'Các bước đơn giản cho bữa tiệc Hibachi hoàn hảo',
		step1: { title: 'Đặt Online', description: 'Chọn ngày, giờ và thực đơn' },
		step2: { title: 'Chúng Tôi Chuẩn Bị', description: 'Đội ngũ chuẩn bị mọi nguyên liệu và thiết bị' },
		step3: { title: 'Thưởng Thức Show', description: 'Xem đầu bếp biểu diễn và thưởng thức món ngon' },
		step4: { title: 'Chúng Tôi Dọn Dẹp', description: 'Thư giãn trong khi chúng tôi lo phần dọn dẹp' },
	},
	menu: {
		title: 'Thực Đơn',
		subtitle: 'Nguyên liệu tươi, hương vị đích thực',
		proteins: 'Món Chính',
		sides: 'Món Phụ & Khai Vị',
		chicken: 'Gà',
		steak: 'Bò Thăn Nội',
		shrimp: 'Tôm',
		salmon: 'Cá Hồi',
		lobster: 'Đuôi Tôm Hùm',
		tofu: 'Đậu Hũ (Chay)',
		scallops: 'Sò Điệp',
		friedRice: 'Cơm Chiên Hibachi',
		noodles: 'Mì Yakisoba',
		vegetables: 'Rau Nướng',
		salad: 'Salad Gừng',
		soup: 'Súp Miso',
		edamame: 'Đậu Nành',
		includes: {
			salad: 'Salad Tươi',
			rice: 'Cơm Chiên',
			vegetables: 'Rau Hibachi',
			show: 'Trò Chơi & Biểu Diễn',
		},
		protein: {
			title: 'Lựa Chọn Protein',
			included: 'Đã Bao Gồm',
		},
		upgrades: {
			title: 'Nâng Cấp Premium',
			filet: 'Bò Thăn Nội',
			lobster: 'Tôm Hùm',
			ribeye: 'Bò Ribeye Premium',
			shrimp: 'Tôm Jumbo',
			salmon: 'Cá Hồi Hoang Dã',
			scallops: 'Sò Điệp Lớn',
		},
		addons: {
			title: 'Thêm Món',
			gyoza: 'Gyoza (12 cái)',
			edamame: 'Đậu Nành',
			noodles: 'Mì',
			thirdProtein: 'Protein thứ 3',
		},
		coupon: {
			title: 'Phiếu Giảm Giá Đặc Biệt',
			subtitle: 'Chỉ áp dụng cho tiệc Chủ nhật đến Thứ sáu!',
			email: 'Email cho chúng tôi tại',
		},
		note: {
			outdoor: 'Chúng tôi chỉ nấu ăn ngoài trời.',
			weather: 'Chúng tôi phục vụ dù mưa hay nắng, miễn là có khu vực khô ráo cho đầu bếp nấu ăn.',
		},
	},
	pricing: {
		title: 'Giá Cả',
		subtitle: 'Giá minh bạch, không phí ẩn',
		perPerson: 'mỗi người',
		minimum: 'Tối thiểu 10 khách',
		includes: 'Bao Gồm',
		includesList: {
			chef: 'Đầu bếp Hibachi chuyên nghiệp',
			ingredients: 'Tất cả nguyên liệu và vật dụng',
			equipment: 'Bếp Hibachi và thiết bị',
			setup: 'Lắp đặt và dọn dẹp',
			show: 'Biểu diễn nấu ăn trực tiếp',
		},
		basic: { title: 'Gói Cơ Bản', description: 'Phù hợp cho buổi họp mặt nhỏ' },
		premium: { title: 'Gói Cao Cấp', description: 'Trải nghiệm Hibachi hoàn chỉnh' },
		deluxe: { title: 'Gói Sang Trọng', description: 'Bữa tối thượng hạng' },
	},
	calendar: {
		available: 'Còn chỗ',
		limited: 'Còn ít',
		busy: 'Bận',
		unavailable: 'Không khả dụng',
		today: 'Hôm nay',
		prevMonth: 'Tháng trước',
		nextMonth: 'Tháng sau',
		weekdays: {
			sun: 'CN',
			mon: 'T2',
			tue: 'T3',
			wed: 'T4',
			thu: 'T5',
			fri: 'T6',
			sat: 'T7',
		},
		months: {
			january: 'Tháng 1',
			february: 'Tháng 2',
			march: 'Tháng 3',
			april: 'Tháng 4',
			may: 'Tháng 5',
			june: 'Tháng 6',
			july: 'Tháng 7',
			august: 'Tháng 8',
			september: 'Tháng 9',
			october: 'Tháng 10',
			november: 'Tháng 11',
			december: 'Tháng 12',
		},
	},
	slider: {
		chef: 'Đầu Bếp Hibachi Chuyên Nghiệp',
		steak: 'Bò Bít Tết Hibachi Thơm Ngon',
		shrimp: 'Tôm Hibachi Tuyệt Vời',
		setup: 'Thiết Bị Hibachi Cao Cấp',
		presentation: 'Bày Trí Món Ăn Đẹp Mắt',
	},
	booking: {
		title: 'Đặt Tiệc',
		subtitle: 'Chọn khu vực để bắt đầu',
		selectRegion: 'Chọn Khu Vực',
		california: 'California',
		texas: 'Texas',
		florida: 'Florida',
		californiaTagline: 'Hibachi chuyên nghiệp tại nhà bạn',
		texasTagline: 'Mang sự xuất sắc của hibachi đến Texas',
		floridaTagline: 'Trải nghiệm hibachi tại bang nắng',
		servingAreas: 'Khu Vực Phục Vụ',
		bookIn: 'Đặt Ngay',
		note: '* Không cần thanh toán. Chúng tôi sẽ liên hệ để xác nhận.',
		quickBook: 'Đặt Nhanh:',
		summary: 'Chi Tiết Đặt Chỗ',
		addToCalendar: 'Thêm Vào Lịch',
	},
	calculator: {
		title: 'Tính Giá',
		subtitle: 'Nhận báo giá ngay lập tức',
		adults: 'Người Lớn',
		kids: 'Trẻ Em (dưới 12)',
		upgrades: 'Nâng Cấp Cao Cấp',
		summary: 'Tóm Tắt Giá',
		subtotal: 'Tạm Tính',
		discount: 'Giảm Giá',
		total: 'Tổng',
		gratuity: 'Tiền Tip Đề Xuất',
		grandTotal: 'Tổng Cộng',
		bookNow: 'Đặt Tiệc',
		note: '* Có thể tính thêm phí di chuyển tùy vị trí.',
		minimumNotice: 'Yêu cầu tối thiểu 10 khách',
	},
	gallery: {
		title: 'Thư Viện Ảnh',
		subtitle: 'Trải nghiệm sự khác biệt Happy Hibachi',
		items: {
			chef: 'Đầu Bếp Hibachi',
			chefDesc: 'Đầu Bếp Hibachi Chuyên Nghiệp Biểu Diễn',
			grill: 'Bếp Nướng Hibachi',
			grillDesc: 'Bếp Nướng Hibachi Cao Cấp',
			steak: 'Bò Hibachi',
			steakDesc: 'Bò Hibachi Ngon',
			vegetables: 'Rau Hibachi',
			vegetablesDesc: 'Rau Hibachi Tươi',
			shrimp: 'Tôm Hibachi',
			shrimpDesc: 'Tôm Hibachi Tuyệt Vời',
			food: 'Trình Bày Món Ăn',
			foodDesc: 'Trình Bày Đẹp Mắt',
		},
	},
	reviews: {
		title: 'Đánh Giá Khách Hàng',
		subtitle: 'Xem khách hàng nói gì về Happy Hibachi',
		bookNow: 'Đặt Tiệc',
		ctaTitle: 'Sẵn Sàng Tạo Trải Nghiệm Tuyệt Vời?',
		ctaText: 'Tham gia cùng hàng trăm khách hàng hài lòng',
		rating: '5.0 Điểm Trung Bình',
		verified: '100+ Đánh Giá Xác Thực',
		topRated: 'Dịch Vụ Hàng Đầu',
	},
	instagram: {
		title: 'Theo Dõi Chúng Tôi',
		followUs: 'THEO DÕI INSTAGRAM',
	},
	referral: {
		title: 'Giới Thiệu Bạn, Nhận Thưởng',
		subtitle: 'Chia sẻ niềm vui hibachi và nhận thưởng!',
		step1Title: 'Chia Sẻ Mã',
		step1Desc: 'Chia sẻ mã giới thiệu với bạn bè',
		step2Title: 'Bạn Bè Đặt',
		step2Desc: 'Bạn bè được giảm $30',
		step3Title: 'Bạn Nhận Thưởng',
		step3Desc: 'Nhận $50 cho sự kiện tiếp theo',
		yourReward: 'Phần Thưởng',
		friendDiscount: 'Giảm Giá Bạn Bè',
		getCode: 'Nhận Mã Giới Thiệu',
		emailPlaceholder: 'Nhập email',
		invalidEmail: 'Email không hợp lệ',
		getCodeBtn: 'Nhận Mã',
		successTitle: 'Mã Đã Sẵn Sàng!',
		successDesc: 'Kiểm tra email để nhận mã.',
		terms: '* Thưởng áp dụng sau khi bạn bè đặt chỗ đầu tiên.',
	},
	newsletter: {
		title: 'Nhận Ưu Đãi Độc Quyền',
		subtitle: 'Đăng ký nhận ưu đãi và mẹo tổ chức tiệc!',
		placeholder: 'Nhập địa chỉ email',
		subscribe: 'Đăng Ký',
		invalidEmail: 'Email không hợp lệ',
		success: 'Cảm ơn! Kiểm tra email để nhận ưu đãi.',
		error: 'Lỗi. Vui lòng thử lại.',
		privacy: 'Chúng tôi tôn trọng quyền riêng tư.',
		benefit1: 'Giảm giá độc quyền',
		benefit2: 'Mẹo tổ chức tiệc',
		benefit3: 'Cập nhật menu mới',
	},
	myBooking: {
		title: 'Kiểm Tra Đặt Chỗ',
		subtitle: 'Nhập email hoặc số điện thoại đã dùng khi đặt',
		emailPlaceholder: 'Nhập địa chỉ email',
		phonePlaceholder: 'Nhập số điện thoại',
		search: 'Tìm Kiếm',
		searching: 'Đang tìm...',
		results: 'Kết Quả',
		noResults: 'Không tìm thấy đặt chỗ',
		error: 'Tìm kiếm thất bại, vui lòng thử lại',
		bookingId: 'Mã Đặt Chỗ',
		needHelp: 'Cần Hỗ Trợ?',
		contactUs: 'Nếu có thắc mắc, hãy liên hệ chúng tôi',
		pendingNote: 'Chúng tôi sẽ liên hệ trong 2 giờ để xác nhận',
		confirmedNote: 'Hẹn gặp bạn! Đầu bếp sẽ đến sớm 30 phút',
	},
	faq: {
		title: 'Câu Hỏi Thường Gặp',
		subtitle: 'Mọi thứ bạn cần biết',
		q1: 'Bạn phục vụ những khu vực nào?',
		a1: 'Hiện chúng tôi phục vụ California, Texas và Florida. Liên hệ để xác nhận vị trí cụ thể.',
		q2: 'Có thể phục vụ bao nhiêu khách?',
		a2: 'Tối thiểu 10 khách, tối đa 50. Sự kiện lớn hơn, vui lòng liên hệ để sắp xếp.',
		q3: 'Tôi cần chuẩn bị gì?',
		a3: 'Bạn chỉ cần chuẩn bị không gian và khách! Chúng tôi mang theo thiết bị, nguyên liệu, dụng cụ và lo phần dọn dẹp.',
		q4: 'Cần đặt trước bao lâu?',
		a4: 'Đề xuất 2 tuần cho ngày thường, 3-4 tuần cho cuối tuần. Ngày hot đặt rất nhanh!',
		q5: 'Có đáp ứng chế độ ăn đặc biệt không?',
		a5: 'Có! Chúng tôi có món chay và đáp ứng hầu hết chế độ ăn kiêng. Vui lòng thông báo khi đặt.',
		q6: 'Chính sách hủy thế nào?',
		a6: 'Hoàn tiền 100% nếu hủy trước 7+ ngày. 50% nếu 3-6 ngày. Không hoàn tiền dưới 3 ngày.',
	},
	contact: {
		title: 'Liên Hệ',
		subtitle: 'Chúng tôi luôn sẵn sàng hỗ trợ',
		phone: 'Điện Thoại',
		email: 'Email',
		hours: 'Giờ Làm Việc',
		address: 'Khu Vực Phục Vụ',
	},
	footer: {
		description: 'Mang trải nghiệm Hibachi đích thực đến nhà bạn',
		quickLinks: 'Liên Kết Nhanh',
		contact: 'Liên Hệ',
		followUs: 'Theo Dõi',
		copyright: '© 2024 Happy Hibachi. Bảo lưu mọi quyền.',
		allRightsReserved: 'Bảo lưu mọi quyền.',
		privacyPolicy: 'Chính Sách Bảo Mật',
		termsOfService: 'Điều Khoản Dịch Vụ',
	},
	menuSelection: {
		title: 'CHỌN LOẠI MÓN',
		subtitle: 'Tất cả bữa ăn bao gồm cơm, rau hibachi và nước sốt đặc biệt',
		regular: {
			title: 'THƯỜNG',
			proteins: '2 món protein mỗi người',
			service: 'Bao gồm show, phục vụ 90 phút',
		},
		premium: {
			title: 'CAO CẤP',
			proteins: '2 protein cao cấp: Bò Thăn, Tôm Hùm, Sò Điệp',
			service: 'Bao gồm show, phục vụ 120 phút',
		},
		catering: {
			title: 'TIỆC LỚN',
			note: '50+ khách kiểu buffet',
			proteins: '2 món protein mỗi người',
			service: 'Bao gồm show, phục vụ 3-4 giờ',
		},
		intimate: {
			title: 'TIỆC NHỎ',
			note: '5-7 khách',
			includes: 'Salad, gyoza, đậu nành, mì + protein hỗn hợp',
			substitution: 'Có thể thay thế protein cùng giá',
		},
	},
	form: {
		name: 'Họ Tên',
		namePlaceholder: 'Nhập họ tên của bạn',
		email: 'Địa Chỉ Email',
		emailPlaceholder: 'Nhập email',
		phone: 'Số Điện Thoại',
		phonePlaceholder: 'Nhập số điện thoại',
		date: 'Ngày Sự Kiện',
		time: 'Thời Gian Mong Muốn',
		guests: 'Số Lượng Khách',
		guestsHint: 'Tối thiểu 10 khách',
		region: 'Chọn Khu Vực',
		eventType: 'Loại Sự Kiện',
		message: 'Tin Nhắn Thêm',
		messagePlaceholder: 'Cho chúng tôi biết về sự kiện của bạn...',
		selectOption: 'Vui lòng chọn',
		selectDate: 'Chọn ngày',
		submit: 'Gửi',
		submitting: 'Đang gửi...',
		submitReservation: 'Gửi Đặt Chỗ',
		success: 'Đặt Chỗ Thành Công!',
		successMessage: 'Đội ngũ sẽ liên hệ trong 2 giờ để xác nhận chi tiết.',
		weWillContact: 'Chúng tôi sẽ liên hệ sớm để xác nhận.',
		error: 'Có lỗi xảy ra. Vui lòng thử lại hoặc gọi trực tiếp.',
		required: 'Bắt buộc',
		people: 'người',
		noPaymentRequired: '* Không cần thanh toán ngay. Chúng tôi sẽ liên hệ xác nhận.',
		invalidEmail: 'Vui lòng nhập email hợp lệ',
		invalidPhone: 'Vui lòng nhập số điện thoại hợp lệ',
		eventTypes: {
			birthday: 'Tiệc Sinh Nhật',
			anniversary: 'Kỷ Niệm',
			graduation: 'Lễ Tốt Nghiệp',
			corporate: 'Sự Kiện Công Ty',
			holiday: 'Tiệc Lễ Hội',
			other: 'Khác',
		},
		referralSource: 'Bạn biết đến chúng tôi qua đâu?',
		referral: {
			google: 'Tìm kiếm Google',
			friend: 'Bạn bè giới thiệu',
			event: 'Thấy tại sự kiện',
			other: 'Khác',
		},
		couponCode: 'Mã Giảm Giá',
		couponPlaceholder: 'Nhập mã giảm giá (tùy chọn)',
		applyCoupon: 'Áp dụng',
	},
	estimate: {
		title: 'Nhận Báo Giá Miễn Phí',
		subtitle: 'Cho chúng tôi biết về sự kiện và nhận báo giá',
		benefits: {
			title: 'Tại Sao Chọn Chúng Tôi?',
			professional: 'Đầu bếp được đào tạo chuyên nghiệp',
			fresh: 'Nguyên liệu tươi chất lượng cao',
			entertainment: 'Biểu diễn nấu ăn trực tiếp',
			cleanup: 'Lắp đặt và dọn dẹp đầy đủ',
			custom: 'Tùy chọn thực đơn linh hoạt',
		},
	},
	bookNow: {
		title: 'Đặt Tiệc Hibachi',
		subtitle: 'Điền mẫu bên dưới để đặt ngày',
		selectRegion: 'Đầu tiên, chọn khu vực',
		formTitle: 'Chi Tiết Sự Kiện',
		pricing: 'Giá từ $45/người',
		note: 'Chúng tôi sẽ xác nhận trong 2 giờ',
	},
	notFound: {
		title: 'Không Tìm Thấy Trang',
		description: 'Trang bạn tìm không tồn tại.',
		backHome: 'Về Trang Chủ',
	},
	common: {
		learnMore: 'Tìm Hiểu Thêm',
		viewAll: 'Xem Tất Cả',
		loading: 'Đang tải...',
		close: 'Đóng',
		backToHome: 'Về Trang Chủ',
		total: 'Tổng',
		toBeConfirmed: 'Chờ xác nhận',
		specialOffer: 'Ưu Đãi Đặc Biệt',
		goTo: 'Đi đến',
		previous: 'Trước',
		next: 'Tiếp',
	},
	topBar: {
		textUs: 'Nhắn Tin',
		email: 'Email',
	},
	photoShare: {
		title: 'Chia Sẻ Ảnh',
		subtitle: 'Chia sẻ trải nghiệm Hibachi và nhận giảm $25 cho sự kiện tiếp theo!',
		option1Title: 'Đăng Lên Instagram',
		option1Desc: 'Tag @happyhibachi và sử dụng #HappyHibachi',
		option2Title: 'Tải Trực Tiếp',
		option2Desc: 'Chia sẻ ảnh với chúng tôi',
		dropzone: 'Kéo thả ảnh vào đây hoặc nhấp để duyệt',
		maxFiles: 'Tối đa 5 ảnh',
		instagramPlaceholder: 'Tên Instagram của bạn (tùy chọn)',
		submit: 'Gửi Ảnh',
		submitting: 'Đang tải...',
		successTitle: 'Ảnh Đã Được Gửi!',
		successDesc: 'Cảm ơn bạn đã chia sẻ! $25 sẽ được áp dụng cho đặt chỗ tiếp theo.',
		terms: '* Tín dụng được áp dụng sau khi ảnh được duyệt. Ảnh có thể được đăng trên mạng xã hội của chúng tôi.',
	},
	offer: {
		noTravel: 'Miễn Phí Di Chuyển',
		within50: 'Trong Vòng 50 Dặm',
		noHidden: 'Không có phí ẩn',
		exclusive: 'Giảm giá độc quyền',
		freeSetup: 'Miễn phí bàn ghế',
		sunFri: 'Ưu Đãi Chủ Nhật đến Thứ Sáu!',
	},
	coupon: {
		minGuests: 'Yêu cầu tối thiểu {{count}} khách',
		applied: 'Mã giảm giá đã áp dụng! Giảm: {{discount}}',
		invalid: 'Mã giảm giá không hợp lệ',
		checkFailed: 'Xác minh thất bại',
		under15: 'dưới 15 người',
		range15to25: '15-25 người',
		range25to35: '25-35 người',
		over35: '35+ người',
	},
	privacy: {
		title: 'Chính Sách Bảo Mật',
		lastUpdated: 'Cập nhật lần cuối: Tháng 1 năm 2026',
		section1: {
			title: '1. Thông Tin Chúng Tôi Thu Thập',
			intro: 'Khi sử dụng dịch vụ Happy Hibachi, chúng tôi có thể thu thập:',
			contact: 'Thông Tin Liên Hệ',
			contactDesc: 'Tên, địa chỉ email, số điện thoại',
			booking: 'Chi Tiết Đặt Chỗ',
			bookingDesc: 'Ngày sự kiện, giờ, địa điểm, số lượng khách',
			payment: 'Thông Tin Thanh Toán',
			paymentDesc: 'Được xử lý an toàn qua nhà cung cấp bên thứ ba',
			usage: 'Dữ Liệu Sử Dụng',
			usageDesc: 'Cách bạn tương tác với trang web của chúng tôi',
		},
		section2: {
			title: '2. Cách Chúng Tôi Sử Dụng Thông Tin',
			item1: 'Xử lý và xác nhận đặt chỗ',
			item2: 'Gửi xác nhận và nhắc nhở đặt chỗ',
			item3: 'Trả lời thắc mắc của bạn',
			item4: 'Cải thiện dịch vụ',
			item5: 'Gửi ưu đãi khuyến mãi (với sự đồng ý của bạn)',
		},
		section3: {
			title: '3. Chia Sẻ Thông Tin',
			intro: 'Chúng tôi không bán thông tin cá nhân. Chúng tôi có thể chia sẻ thông tin với:',
			item1: 'Nhà cung cấp dịch vụ hỗ trợ hoạt động',
			item2: 'Cơ quan pháp luật khi được yêu cầu',
		},
		section4: {
			title: '4. Bảo Mật Dữ Liệu',
			desc: 'Chúng tôi áp dụng các biện pháp bảo mật phù hợp để bảo vệ thông tin cá nhân. Tuy nhiên, không có truyền tải internet nào an toàn 100%.',
		},
		section5: {
			title: '5. Quyền Của Bạn',
			intro: 'Bạn có quyền:',
			item1: 'Truy cập dữ liệu cá nhân',
			item2: 'Yêu cầu sửa dữ liệu không chính xác',
			item3: 'Yêu cầu xóa dữ liệu',
			item4: 'Từ chối nhận thông tin tiếp thị',
		},
		section6: {
			title: '6. Cookies',
			desc: 'Chúng tôi sử dụng cookies để cải thiện trải nghiệm duyệt web và phân tích lưu lượng truy cập. Bạn có thể kiểm soát cookies qua cài đặt trình duyệt.',
		},
		section7: {
			title: '7. Liên Hệ',
			intro: 'Câu hỏi về quyền riêng tư:',
		},
	},
	terms: {
		title: 'Điều Khoản Dịch Vụ',
		lastUpdated: 'Cập nhật lần cuối: Tháng 1 năm 2026',
		section1: {
			title: '1. Dịch Vụ',
			desc: 'Happy Hibachi cung cấp dịch vụ tiệc hibachi di động. Chúng tôi mang đầu bếp chuyên nghiệp và thiết bị đến địa điểm của bạn để chuẩn bị bữa ăn hibachi chính hiệu.',
		},
		section2: {
			title: '2. Đặt Chỗ',
			minimum: 'Số Khách Tối Thiểu',
			minimumDesc: 'Yêu cầu tối thiểu 10 khách',
			confirmation: 'Xác Nhận',
			confirmationDesc: 'Đặt chỗ được xác nhận sau khi đội ngũ liên hệ',
			deposit: 'Đặt Cọc',
			depositDesc: 'Có thể yêu cầu đặt cọc để giữ ngày',
			finalCount: 'Số Lượng Cuối',
			finalCountDesc: 'Số khách phải được xác nhận 48 giờ trước sự kiện',
		},
		section3: {
			title: '3. Chính Sách Hủy',
			sevenDays: 'Trên 7 ngày',
			sevenDaysDesc: 'Hoàn tiền đặt cọc đầy đủ',
			threeSixDays: '3-6 ngày',
			threeSixDaysDesc: 'Hoàn 50% tiền đặt cọc',
			lessThanThree: 'Dưới 3 ngày',
			lessThanThreeDesc: 'Không hoàn tiền đặt cọc',
			weather: 'Thời Tiết',
			weatherDesc: 'Đổi lịch miễn phí khi thời tiết xấu',
		},
		section4: {
			title: '4. Trách Nhiệm Khách Hàng',
			intro: 'Khách hàng cần cung cấp:',
			item1: 'Không gian nấu nướng ngoài trời đủ rộng (tối thiểu 10x10 feet)',
			item2: 'Nguồn điện (ổ cắm tiêu chuẩn trong vòng 50 feet)',
			item3: 'Bàn ghế cho khách',
			item4: 'Bảo vệ thời tiết nếu cần (lều, nhà mái, v.v.)',
		},
		section5: {
			title: '5. An Toàn Thực Phẩm & Dị Ứng',
			desc: 'Vui lòng thông báo về dị ứng thực phẩm hoặc hạn chế ăn kiêng khi đặt chỗ. Dù chúng tôi cẩn thận, không thể đảm bảo môi trường hoàn toàn không có chất gây dị ứng do đặc thù nấu hibachi.',
		},
		section6: {
			title: '6. Trách Nhiệm Pháp Lý',
			desc: 'Happy Hibachi có bảo hiểm trách nhiệm. Tuy nhiên, khách hàng chịu trách nhiệm về khách mời và tài sản. Chúng tôi không chịu trách nhiệm về tai nạn do hành vi của khách hoặc tình trạng tài sản có sẵn.',
		},
		section7: {
			title: '7. Khu Vực Phục Vụ',
			intro: 'Chúng tôi hiện phục vụ:',
			california: 'California (Los Angeles, San Diego, San Francisco và vùng lân cận)',
			texas: 'Texas (Houston, Dallas, Austin, San Antonio và vùng lân cận)',
			florida: 'Florida (Miami, Fort Lauderdale và vùng lân cận)',
			travelFee: 'Có thể áp dụng phí di chuyển cho địa điểm ngoài khu vực phục vụ tiêu chuẩn.',
		},
		section8: {
			title: '8. Thay Đổi Điều Khoản',
			desc: 'Chúng tôi bảo lưu quyền sửa đổi các điều khoản này bất cứ lúc nào. Việc tiếp tục sử dụng dịch vụ đồng nghĩa với việc chấp nhận các điều khoản cập nhật.',
		},
		section9: {
			title: '9. Liên Hệ',
			intro: 'Câu hỏi về điều khoản:',
		},
	},
	status: {
		pending: 'Đang chờ',
		confirmed: 'Đã xác nhận',
		completed: 'Hoàn thành',
		cancelled: 'Đã hủy',
	},
	timeSlot: {
		afternoon: 'Buổi chiều',
		evening: 'Buổi tối',
		night: 'Đêm',
	},
	admin: {
		login: {
			title: 'Đăng Nhập Admin',
			subtitle: 'Nhập mật khẩu để tiếp tục',
			password: 'Mật Khẩu',
			loginButton: 'Đăng Nhập',
			loggingIn: 'Đang đăng nhập...',
			invalidPassword: 'Mật khẩu không đúng',
			loginFailed: 'Đăng nhập thất bại',
			contactHelp: 'Liên hệ hỗ trợ',
		},
		dashboard: {
			title: 'Bảng Điều Khiển',
			logout: 'Đăng Xuất',
		},
		stats: {
			totalBookings: 'Tổng',
			pending: 'Chờ Xử Lý',
			confirmed: 'Đã Xác Nhận',
			completed: 'Hoàn Thành',
			cancelled: 'Đã Hủy',
			totalGuests: 'Tổng Khách',
		},
		tabs: {
			all: 'Tất Cả',
			pending: 'Chờ Xử Lý',
			confirmed: 'Đã Xác Nhận',
			completed: 'Hoàn Thành',
			cancelled: 'Đã Hủy',
		},
		booking: {
			noBookings: 'Không có đặt chỗ',
			noBookingsHint: 'Đặt chỗ sẽ hiển thị ở đây',
			guests: 'khách',
			booking: 'Đặt Chỗ',
			estimate: 'Báo Giá',
			contactInfo: 'Thông Tin Liên Hệ',
			eventDetails: 'Chi Tiết Sự Kiện',
			date: 'Ngày',
			time: 'Giờ',
			notSpecified: 'Chưa chỉ định',
			region: 'Khu Vực',
			additionalNotes: 'Ghi Chú Thêm',
			updateStatus: 'Cập Nhật Trạng Thái',
			emailCustomer: 'Gửi Email',
			callCustomer: 'Gọi Điện',
		},
	},
};

export default vi;

